import Moment from 'moment';
import 'moment/locale/pt-br';

Moment.locale('pt-br');

export function calculaTempo(data) {
  if (!data) return '';
  const momento = Moment(data);
  if (!momento.isValid()) return '';
  return momento.fromNow();
}
